module.exports = __webpack_public_path__ + "static/media/draft.36f310ba.png";